export default __webpack_public_path__ + "static/media/referral-banner-1.7445c945.png";